import { Injectable } from '@angular/core';
import { GlobalEmailTypes } from '../constants-types/Enums';
import { DefaultEmailSettingDescription } from '../core-data-model/DefaultEmailSettingDescription';
import { CustomEmailSetting } from '../core-data-model/EmailDefault.model';
import {
    CustomEmailSettingServer,
    DefaultEmailSettingServer
} from '../core-data-model/EmailDefaultApi.serverinterface';
import { ApiService } from '../system-services/Api.service';
import { UserProfileSettingsService } from '../system-services/UserProfileSettings/UserProfileSettings.service';
import { TranslationService } from '../translations';

@Injectable({
    providedIn: 'root'
})
export class EmailDefaultApi {
    private excludedDefaultTypes = [
        GlobalEmailTypes[GlobalEmailTypes.CoachingGuide],
        GlobalEmailTypes[GlobalEmailTypes.ManagementStrategyGuide],
        GlobalEmailTypes[GlobalEmailTypes.ManagerDevelopmentChart],
        GlobalEmailTypes[GlobalEmailTypes.BehavioralAssessmentResultsEmail],
        GlobalEmailTypes[GlobalEmailTypes.StrategyAssessmentEmail]
    ];

    constructor(
        private api: ApiService,
        private userProfile: UserProfileSettingsService,
        private TR: TranslationService
    ) {}

    getEmailDefaultTypes(
        languageLocale: string = this.TR.currentLocale,
        companyId: string = this.userProfile.currentCompany
    ): Promise<DefaultEmailSettingDescription[]> {
        return this.api
            .get<
                DefaultEmailSettingServer[]
            >(`/api/v4/companies/${companyId}/emailsettings/default?languageLocale=${languageLocale}`)
            .then(([response]) =>
                response
                    .filter(
                        (ele) =>
                            !this.excludedDefaultTypes.includes(ele.emailType)
                    )
                    .map((item) => {
                        const emailDefault =
                            new DefaultEmailSettingDescription();
                        emailDefault.globalEmailDescription = item.description;
                        emailDefault.globalEmailTypeId = GlobalEmailTypes[
                            item.emailType as any
                        ] as any;
                        return emailDefault;
                    })
            );
    }

    getEmailDefaultDetails(
        emailType: GlobalEmailTypes,
        languageLocale: string = this.TR.currentLocale,
        companyId: string = this.userProfile.currentCompany
    ): Promise<CustomEmailSetting> {
        return this.api
            .get<CustomEmailSettingServer>(
                `/api/v4/companies/${companyId}/emailsettings/custom/${GlobalEmailTypes[emailType]}?languageLocale=${languageLocale}`
            )
            .then(([response]) => {
                const emailDefault = new CustomEmailSetting();
                emailDefault.message = response.message;
                emailDefault.subject = response.subject;
                return emailDefault;
            });
    }

    setEmailDefaultDetails(
        emailType: GlobalEmailTypes,
        emailDefault: CustomEmailSetting,
        languageLocale: string = this.TR.currentLocale,
        companyId: string = this.userProfile.currentCompany
    ): Promise<CustomEmailSetting> {
        return this.api
            .put<any>(
                `/api/v4/companies/${companyId}/emailsettings/custom/${GlobalEmailTypes[emailType]}?languageLocale=${languageLocale}`,
                emailDefault
            )
            .then(() => emailDefault);
    }
}
